/* eslint-disable @typescript-eslint/ban-ts-comment */
import gql from 'graphql-tag'
import { sortBy } from 'lodash'
import client from '@stores/apollo'
import { PortfolioBuildingFragment } from '@api/fragments'
import { IPortfolioBuilding, IPortfolioFloor } from '@api'

interface IProps {
  assignmentPlanId: string
  cities: string[]
  includeOldBuildings: boolean
  includeDepartment: boolean
}
export default function ({
  assignmentPlanId,
  cities,
  includeOldBuildings,
  includeDepartment,
}: IProps): Promise<IPortfolio> {
  const variables = {
    assignmentPlanId,
    cities,
    includeOldBuildings,
    includeDepartment,
  }
  return client.gql.query({ query: portfolioQuery, variables }).then((response: IPortfolio) => {
    const buildings = response.data.viewer.company.portfolio?.buildings
    for (const building of buildings) {
      building.floors = sortBy(building.floors, 'floor.story') as IPortfolioFloor[]
      const b = building.building
      // @ts-ignore
      if (!b.notifications.edges) continue
      // @ts-ignore
      b.notifications = b.notifications?.edges?.map((e) => e.node)
      for (const floor of building.floors) {
        const f = floor.floor
        // @ts-ignore
        f.notifications = f.notifications?.edges?.map((e) => e.node)
      }
    }

    return response
  })
}

export const portfolioQuery = gql`
  query portfolioQuery(
    $assignmentPlanId: ID!
    $cities: [String]
    $includeDepartment: Boolean
    $includeUsageType: Boolean
    $includeSpaceType: Boolean
    $includeOldBuildings: Boolean
  ) {
    viewer {
      company {
        name
        portfolio(
          assignmentPlanId: $assignmentPlanId
          cities: $cities
          includeDepartment: $includeDepartment
          includeUsageType: $includeUsageType
          includeSpaceType: $includeSpaceType
          includeOldBuildings: $includeOldBuildings
        ) {
          rollUps {
            buildings
            floors
            spaces
            workstations
            workstationsAvailable
          }
          normalOccupancy
          alertOccupancy
          buildings {
            ...PortfolioBuildingFragment
          }
        }
      }
    }
  }
  ${PortfolioBuildingFragment}
`

interface IPortfolio {
  data: {
    viewer: {
      company: {
        name: string
        portfolio: {
          buildings: IPortfolioBuilding[]
          alertOccupancy: number
          normalOccupancy: number
        }
      }
    }
  }
}
